export const GameActionTypes = {
    CHANGE_GAME: '@@game/CHANGE_GAME',
    CHANGE_PARTY: '@@game/CHANGE_PARTY',
    SHOW_ALERT: '@@game/SHOW_ALERT',
};
